"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelStateProxy = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
function cloneDrawableStates(source) {
    var e_1, _a;
    var drawableStates = mobx_1.observable.map();
    try {
        for (var _b = tslib_1.__values(Array.from(source.entries())), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), captureId = _d[0], drawableState = _d[1];
            drawableStates.set(captureId, drawableState.clone());
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return drawableStates;
}
var CollectionModelStateProxy = /** @class */ (function () {
    function CollectionModelStateProxy(state) {
        this.frozen = false;
        /**
         * Drawable state is NOT proxied -- it starts as a full copy of the original state.
         */
        this.drawableStates = mobx_1.observable.map();
        this.internalState = state;
        this.resetDrawables();
    }
    Object.defineProperty(CollectionModelStateProxy.prototype, "loader", {
        get: function () { return this.internalState.loader; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "id", {
        get: function () { return this.internalState.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "instanceId", {
        get: function () { return this.internalState.instanceId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "uuid", {
        get: function () { return this.internalState.uuid; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "revision", {
        get: function () { return this.internalState.revision; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "jobId", {
        get: function () { return this.internalState.jobId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "updatedAt", {
        get: function () { return this.internalState.updatedAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "updatedBy", {
        get: function () { return this.internalState.updatedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "createdAt", {
        get: function () { return this.internalState.createdAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "collectedAt", {
        get: function () { return this.internalState.collectedAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "collectedBy", {
        get: function () { return this.internalState.collectedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "collectedWith", {
        get: function () { return this.internalState.collectedWith; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "assignedTo", {
        get: function () { return this.internalState.assignedTo; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "isDirty", {
        get: function () {
            var _a;
            return ((_a = this.fields.size) !== null && _a !== void 0 ? _a : 0) > 0 || this.drawableStateHasChanged();
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelStateProxy.prototype.drawableStateHasChanged = function () {
        // Only compare the drawable states which have drawables in them,
        // because CollectionModelState may or may not have drawableStates for captures with no drawables,
        // but it always has drawable states for captures with drawables.
        var e_2, _a;
        var drawableStates = Array.from(this.drawableStates.values()).filter(function (ds) { return !ds.empty; });
        var internalDrawableStates = Array.from(this.internalState.drawableStates.values()).filter(function (ds) { return !ds.empty; });
        var keys = Array.from(drawableStates.keys());
        var internalKeys = Array.from(internalDrawableStates.keys());
        if (keys.length !== internalKeys.length) {
            return true;
        }
        if (keys.some(function (key) { return !internalKeys.includes(key); })) {
            return true;
        }
        if (internalKeys.some(function (key) { return !keys.includes(key); })) {
            return true;
        }
        var _loop_1 = function (drawableState) {
            var originalDrawableState = internalDrawableStates.find(function (ds) { return ds.captureId === drawableState.captureId; });
            if (!originalDrawableState) {
                return { value: true };
            }
            if (!drawableState.equals(originalDrawableState)) {
                return { value: true };
            }
        };
        try {
            for (var drawableStates_1 = tslib_1.__values(drawableStates), drawableStates_1_1 = drawableStates_1.next(); !drawableStates_1_1.done; drawableStates_1_1 = drawableStates_1.next()) {
                var drawableState = drawableStates_1_1.value;
                var state_1 = _loop_1(drawableState);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (drawableStates_1_1 && !drawableStates_1_1.done && (_a = drawableStates_1.return)) _a.call(drawableStates_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return false;
    };
    CollectionModelStateProxy.prototype.reset = function () {
        this.fields.clear();
        this.geometries.clear();
        this.resetDrawables();
    };
    CollectionModelStateProxy.prototype.resetDrawables = function () {
        var e_3, _a;
        this.drawableStates.clear();
        try {
            for (var _b = tslib_1.__values(Array.from(cloneDrawableStates(this.internalState.drawableStates).entries())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), captureId = _d[0], drawableState = _d[1];
                this.drawableStates.set(captureId, drawableState);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    CollectionModelStateProxy.prototype.getFieldValue = function (fieldId) {
        if (this.fields.has(fieldId)) {
            return this.fields.get(fieldId);
        }
        return this.internalState.getFieldValue(fieldId);
    };
    CollectionModelStateProxy.prototype.setFieldValue = function (fieldId, state) {
        var internalValue = this.internalState.getFieldValue(fieldId);
        if (JSON.stringify(state) === JSON.stringify(internalValue)) {
            this.fields.delete(fieldId);
        }
        else {
            this.fields.set(fieldId, state);
        }
    };
    CollectionModelStateProxy.prototype.hasFieldValue = function (fieldId) {
        return this.getFieldValue(fieldId) != null;
    };
    CollectionModelStateProxy.prototype.getDrawable = function (captureId, drawableId) {
        var _a;
        if ((_a = this.drawableStates[captureId]) === null || _a === void 0 ? void 0 : _a.hasDrawable(drawableId)) {
            return this.drawableStates[captureId].getDrawable(drawableId);
        }
        throw new Error("Drawable ".concat(drawableId, " (capture ").concat(captureId, ") not found in proxy state"));
    };
    CollectionModelStateProxy.prototype.getCapture = function (captureId) {
        return this.internalState.getCapture(captureId);
    };
    CollectionModelStateProxy.prototype.getCalibration = function (calibrationId) {
        return this.internalState.getCalibration(calibrationId);
    };
    CollectionModelStateProxy.prototype.getGeometry = function (captureId) {
        return this.internalState.getGeometry(captureId);
    };
    CollectionModelStateProxy.prototype.getCollection = function (uuid) {
        return this.internalState.getCollection(uuid);
    };
    /**
     * @deprecated This method can create race conditions; use `getCollectionModelAsync()` instead.
     */
    CollectionModelStateProxy.prototype.getCollectionModel = function (collectionId) {
        return this.internalState.getCollectionModel(collectionId);
    };
    CollectionModelStateProxy.prototype.getCollectionModelAsync = function (collectionId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.internalState.getCollectionModelAsync(collectionId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectionModelStateProxy.prototype.freeze = function () {
        throw new Error('Cannot freeze edit state');
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelStateProxy.prototype, "drawableStates", void 0);
    return CollectionModelStateProxy;
}());
exports.CollectionModelStateProxy = CollectionModelStateProxy;
//# sourceMappingURL=collection.state.proxy.js.map